export default __webpack_public_path__ + "static/media/9.85e064a0.jpg";